/**
 * Org Param Group: Exibição de registros ('display')
 *
 * Company-wide config for how entity records appear in lookups (and, in the
 * future, FK grid columns / printing). Request 0077 (spec 0028 Fase 1).
 *
 * Parameters (both policy, orgEditable: false, edited in organization-manager):
 *   productLabelFormat        — which `EntityDisplayFormat` to use for Product
 *   productVariantLabelFormat — how to combine the formatted product label
 *                               with its variation values
 */
import { ENTITY_DISPLAY_FORMATS } from '../display/entityLabelFormat.js';
const parameters = [
    {
        key: 'productLabelFormat',
        label: 'Formato do produto nos lookups',
        type: 'enum',
        scope: 'module',
        options: ENTITY_DISPLAY_FORMATS['Product'].available,
        default: ENTITY_DISPLAY_FORMATS['Product'].default,
        required: false,
    },
    {
        key: 'productVariantLabelFormat',
        label: 'Formato da variação de produto',
        type: 'enum',
        scope: 'module',
        options: ['product-values', 'values-product'],
        default: 'product-values',
        required: false,
    },
];
export const displayOrgParamGroup = {
    key: 'display',
    label: 'Exibição de registros',
    version: 1,
    parameters,
};
//# sourceMappingURL=display.orgParamGroup.js.map